import { Box } from '@mui/material';
import { TableTitleBox } from '../../../common/components';
import { DIFFERIMENT_TABLE_TITLE } from './constants/differimentsConstants';
import DifferimentsFilters from './components/DifferimentsFilters';
import DifferimentsDataTable from './components/DifferimentsDataTable';
import DifferimentDetailDialog from './components/detailDialog/DifferimentDetailDialog';
import DifferimentPaymentDialog from './components/payDialog/DifferimentPaymentDialog';
import { useDifferimentsTable } from './hooks/useDifferimentsTable';
import { PaginationTable } from '../../../common/components';
import { useDifferimentPaymentPrint } from '../../../hooks/useDifferimentPayments';

const DifferimentsTable = () => {
  const printMutation = useDifferimentPaymentPrint();
  const {
    search,
    setSearch,
    data,
    isLoading,
    isFetching,
    isError,
    handleFetch,
    totalCount,
    totalPages,
    page,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    openDetail,
    closeDetail,
    selectedContract,
    detailQuery,
    openPayments,
    closePayments,
    selectedPaymentContract,
    paymentDetailQuery,
  } = useDifferimentsTable();

  return (
    <Box>
      <TableTitleBox title={DIFFERIMENT_TABLE_TITLE} />

      <DifferimentsFilters
        search={search}
        onSearchChange={setSearch}
        onFetch={handleFetch}
        isFetching={isFetching}
      />

      <DifferimentsDataTable
        data={data}
        isLoading={isLoading}
        isFetching={isFetching}
        showError={isError}
        onView={openDetail}
        onPay={openPayments}
      />
      <PaginationTable
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        onPageChange={handlePageChange}
      />

      <DifferimentDetailDialog
        open={Boolean(selectedContract)}
        onClose={closeDetail}
        detail={detailQuery.data}
        isLoading={detailQuery.isFetching}
      />
      <DifferimentPaymentDialog
        open={Boolean(selectedPaymentContract)}
        onClose={closePayments}
        detail={paymentDetailQuery.data}
        isLoading={paymentDetailQuery.isFetching}
        onPrint={(uuid) => printMutation.mutate(uuid)}
        onRefresh={() => paymentDetailQuery.refetch()}
      />
    </Box>
  );
};

export default DifferimentsTable;
